export function selectSummary(state) {
  return state.statistics.summary;
}
